<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-eye', fontSet: 'fad'}"
	[headerText]="T.JSON_VIEW_DIALOG_TITLE | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="jsonHolderCon">
			<ngx-json-viewer [json]="data.elementToShow" />
		</div>
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'close'})"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-times'}"
			[label]="T.BUTTON_CLOSE"
			color="warn"
		/>
	</ng-container>
</sim-basic-material-dialog>
